import React from "react";
import Image from "pages/_components/Image";
import { string, bool } from "prop-types";
import { useHistory } from "react-router-dom";
import Button from "pages/_components/Button";
import CustomText from "./CustomText/CustomText";

const ShortcutAction = (props) => {
    const { color, href, icon, isMobile, label } = props;
    const history = useHistory();
    const handlePush = () => {
        history.push(href);
    };
    return (
        <>
            <Button className={`btn-big ${color}`} onClick={handlePush} block={false}>
                {!isMobile ? (
                    <div className="svg-wrapper svg-background">
                        <Image className="svg-icon icon-medium" src={`images/figma/icon/${icon}.svg`} />
                    </div>
                ) : (
                    <Image className="svg-icon icon-large" src={`images/figma/icon/${icon}.svg`} />
                )}
                <CustomText text={label} className="custom-data-value" />

                {!isMobile && (
                    <p className="medium color-primary-text pull-left rotate-icon">
                        <Image className="svg-icon icon-small " src="images/styledmenu-arrow-down-white.svg" />
                    </p>
                )}
            </Button>
        </>
    );
};

ShortcutAction.defaultProps = {
    label: "",
    color: "",
    href: null,
    icon: "",
    isMobile: false,
};

ShortcutAction.propTypes = {
    label: string,
    href: string,
    icon: string,
    color: string,
    isMobile: bool,
};

export default ShortcutAction;
